import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ErrorModalHelperService } from '../../_helpers/error-modal-helper/error-modal-helper.service';
import { SpinnerService } from '../../_services/spinner/spinner.service';

@Component({
    selector: 'loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.css'],
    animations: [
        trigger('fade', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('0.3s ease', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate('0.3s ease', style({ opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class LoadingSpinnerComponent implements OnInit, OnDestroy {
  @Input("shotHintOverwrite") shotHintOverwrite: boolean = true;

  public hint: string = "";
  public showHint: boolean = false;
  private timerId: any;

  constructor(public spinnerService: SpinnerService) { }

  ngOnInit() {
    this.setHint();
    this.startIntervalTimer();
  }
  
  ngOnDestroy(): void {
    clearInterval(this.timerId);
  }
  
  private startIntervalTimer(): void {
    this.timerId = setInterval(() => {
      this.setHint();
    }, 5000);
  }

  private setHint():  void {
    this.showHint = false;
    setTimeout(() => {
      const rndInt = Math.floor(Math.random() * this.spinnerService.hints.length) + 1
      this.hint = this.spinnerService.hints[rndInt - 1];
      this.showHint = true;
    }, 300);
  }

}
